import { useStore } from 'effector-react'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Button } from '~/shared/ui/Buttons'
import { Modal } from '~/shared/ui/Modal'
import { submit, submitFx } from './model'

type ChangeCurrentOccupationModalProps = {
  isShow: boolean
  onClose: () => void
  occupationId?: UniqueId
}

export function ChangeCurrentOccupationModal({
  isShow,
  onClose,
  occupationId,
}: ChangeCurrentOccupationModalProps) {
  const isSubmitting = useStore(submitFx.pending)

  const handleSubmit = () => {
    if (!occupationId) {
      snackbarEnqueued({
        message: 'Тип занятости не выбран / не найден',
        variant: 'danger',
      })
      return
    }
    submit({ occupationId, fn: onClose })
  }

  return (
    <Modal isShow={isShow} canBackdropClose={false}>
      <div
        data-testid='modal-title'
        style={{ fontSize: '16px', fontWeight: '700', marginBottom: '8px' }}
      >
        Смена типа занятости
      </div>

      <div
        style={{ fontSize: '16px', marginBottom: '16px', lineHeight: '24px' }}
      >
        При смене типа занятости у вас будет изменен аккаунт в Яндекс Fleet, и
        будет запущен процесс переноса баланса с текущего аккаунта на выбранный.
      </div>

      <Button
        variant='limeFlooded'
        fullWidth
        onClick={handleSubmit}
        loading={isSubmitting}
        style={{ marginBottom: '16px' }}
      >
        Подтвердить
      </Button>

      <Button
        fullWidth
        variant='lightSteelBlueBorder'
        onClick={onClose}
        disabled={isSubmitting}
      >
        Отмена
      </Button>
    </Modal>
  )
}
